<template>
  <div class="preloader" />
</template>

<script setup lang="ts">
// No logic or props to convert; the component is empty.
</script>

<style lang="scss" scoped>
@keyframes placeHolderShimmer {
  0% {
    background-position: -1900px 0;
  }
  100% {
    background-position: 1900px 0;
  }
}

.preloader {
  animation-duration: 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-color: #f6f7f8;
  background: linear-gradient(125deg, #f7f7f7 8%, #ececec 18%, #f7f7f7 33%);
  background-size: 1900px 300px;
}
</style>
